export default __webpack_public_path__ + "static/media/carousel9.0cccb282.jpg";